import { UserRole } from '@core/constants';

export class AccessToken {
    username: string;
    roles: UserRole[];
    expiresOn: Date;
    scopes: string[];

    constructor(username: string, roles: UserRole[], expiresOn: Date, scopes: string[]) {
        this.username = username;
        this.roles = roles;
        this.expiresOn = expiresOn;
        this.scopes = scopes;
    }
}
